<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="nom"
          @change="v => $emit('update:nom', v)"
          label="Nom du client"
          :rules="[v => !!v || 'Un nom est requis']"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="telephone"
          @change="v => $emit('update:telephone', v)"
          label="Téléphone"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="courriel"
          @change="v => $emit('update:courriel', v)"
          label="Courriel"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="adresse"
          @change="v => $emit('update:adresse', v)"
          label="Adresse"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: "CustomerFields",
  props: {
    nom: {
      type: String,
      required: true
    },
    telephone: {
      type: String,
      required: true
    },
    courriel: {
      type: String,
      required: true
    },
    adresse: {
      type: String,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style></style>
